<template>
  <div class="c-dmp-wrapper">
    <!-- filter -->
    <dmp-filter
      slot="filter"
      :loading="loading"
      :operator-data="operatorData"
      :platform-data="platformData"
      :stat-data="statData"
      :auth-add-btn="authAddBtn"
      :auth-batch-btn="authBatchBtn"
      @on-change="filterData"
      @on-add="openNew"
      @on-batch="handleBatch"
      @batch-del="batchDel"
    />
    <!-- table -->
    <Viewport v-model="tableHeight">
      <el-table
        ref="table"
        border
        class="common-el-table-styles"
        v-loading="loading"
        :data="tableData"
        :height="tableHeight"
        :cell-class-name="cellClassName"
        @selection-change="changeSelection"
      >
        <el-table-column v-if="tableColumns.length" type="selection" width="30"></el-table-column>
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
              <el-button type="text" v-if="authPushBtn" @click="hrefClick(scope.row)">推送详情</el-button>
              <el-button type="text" v-if="authRetryBtn" v-loading="scope.row._reting" @click="retryClick(scope.row)"> 重试 </el-button>
            </div>
            <div v-else-if="col.key === 'excludeMediaNames'" class="">
              <div v-if="isArray(scope.row[col.key]) && scope.row[col.key].length" class="tag-wrap">
                <Tag v-for="tag of scope.row[col.key]" :key="tag">{{ tag }}</Tag>
              </div>
              <span v-else>未开启</span>

              <Icon v-if="authSetBtn" type="md-create" class="g-pull-right m-edit" size="18" @click="editSet(scope.row)" />
            </div>
            <span v-else-if="col.key === 'platform'">{{ cellPlatform(scope.row[col.key]) }}</span>
            <span v-else-if="col.key === 'dmpStatus'">
              {{ cellStatus(scope.row[col.key]) }}{{ scope.row.errorMsg ? `，${scope.row.errorMsg}` : '' }}
            </span>
            <span v-else-if="col.key === 'dmpType'">{{ scope.row[col.key] | cellDmpType }}</span>
            <div v-else-if="col.key === 'autoSwitch'">
              <i-Switch
                v-model="scope.row.autoSwitch"
                size="small"
                :true-value="1"
                :false-value="0"
                @on-change="changeStatus($event, scope.row)"
              />
            </div>
            <!-- <span v-else-if="col.key === 'autoSwitch'">{{scope.row[col.key] | cellAutoSwitch}}</span> -->
            <span v-else-if="col.key === 'total'">{{ scope.row[col.key] | toThousands }}</span>
            <span v-else-if="['createTime', 'updateTime', 'synTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>

    <Modal v-model="model" title="媒体排除设置" :width="540" :closable="false" :mask-closable="false" class-name="vertical-center-modal">
      <Form :label-width="140">
        <FormItem label="自动排除人群包">
          <CheckboxGroup v-model="excludeMedia">
            <Checkbox :label="10">巨量引擎</Checkbox>
            <Checkbox :label="16">腾讯</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <template slot="footer">
        <div class="m-foot">
          <Button @click="model = false">取消</Button>
          <Button type="primary" :loading="saving" @click="save">
            <span v-if="saving">提交中...</span>
            <span v-else>确认</span>
          </Button>
        </div>
      </template>
    </Modal>

    <set-batch v-model="batch" :data="selectionRow" @on-submit="batchDeliverDmp" @on-cancel="cancelBatch" />
    <batch-result v-model="batchResult" :table-data="batchResultData" @on-close="batchResultClose" />
  </div>
</template>
<script>
import { isArray, isEmpty } from '@/common/js/utils'
import mixin from '../mixins/mixin'
import mixinPage from '../mixins/mixin_page'
import tableColumns from '../data/dmp_columns'
import DmpFilter from './components/dmp-filter'
import SetBatch from './components/set-batch'
import BatchResult from './components/batch-result'

import {
  dmpMangePackage,
  setAutoUpdatePackage,
  delDmpPackageById,
  retryDmpPackageById,
  setExcludeMedia,
  dmpBatchDeliver,
  batchDeleteDmpPackage
} from '@/api/manage.model'

export default {
  name: 'DMPData',
  mixins: [mixin, mixinPage],
  components: { DmpFilter, SetBatch, BatchResult },
  computed: {
    authAddBtn() {
      return isArray(this.access) && this.access.includes('M20808')
    },
    authDelBtn() {
      return isArray(this.access) && this.access.includes('M20811')
    },
    authUpdateBtn() {
      return isArray(this.access) && this.access.includes('M20810')
    },
    authSetBtn() {
      return isArray(this.access) && this.access.includes('M20809')
    },
    authPushBtn() {
      return isArray(this.access) && this.access.includes('M20806')
    },
    authRetryBtn() {
      return isArray(this.access) && this.access.includes('M20813')
    },
    authBatchBtn() {
      return isArray(this.access) && this.access.includes('M20818')
    }
  },
  data() {
    return {
      model: null,
      batch: null,
      batchResult: null,
      saving: null,
      loading: null,
      tableHeight: 0,
      tableData: [],
      tableColumns: [],
      operatorData: [], // 系统人员
      excludeMedia: [], // 自动排除媒体
      access: this.$store.state.accessAuth,
      batchResultData: [], // 批量推送结果
      statData: [
        { id: -1, name: '包体生成未开始' },
        { id: 1, name: '包体生成完成' },
        { id: 0, name: '包体生成中' },
        { id: 2, name: '包体压缩完成' },
        { id: 4, name: '包体生成失败' },
        { id: 6, name: '媒体包体失败' },
        { id: 3, name: '媒体包体成功' },
        { id: 5, name: '媒体压缩失败' }
      ],
      platformData: [
        { id: 1, name: 'Andriod' },
        { id: 2, name: 'iOS' }
      ],
      selectionRow: [],
      autoSwitch: 0
    }
  },
  methods: {
    isArray,

    cellClassName({ column }) {
      if (column.property === 'excludeMediaNames') return 'exclude-media-names'
      return ''
    },

    cellPlatform(cell) {
      if (isEmpty(cell)) return ''
      else return this.platformData.filter((ret) => ret.id === cell).pop().name
    },
    cellStatus(cell) {
      if (isEmpty(cell)) return ''
      else return this.statData.filter((ret) => ret.id === cell).pop().name
    },
    openNew() {
      this.$router.push({ name: 'dmpadd' })
    },
    editClick(row) {
      if (!row || !row.id) return
      this.$router.push({ name: 'dmpadd', query: { t: 'edit', id: row.id, autoSwitch: row.autoSwitch } })
    },
    hrefClick(row) {
      if (!row || !row.id) return
      this.$router.push({ name: 'dmppush', query: { id: row.id } })
    },
    retryClick(row) {
      if (!row || !row.id) return
      this.$set(row, '_reting', true)
      retryDmpPackageById({ id: row.id }).then((data) => {
        if (typeof data !== 'symbol') {
          this.$set(row, '_reting', false)
          this.getData()
        }
      })
    },
    delClick(row) {
      if (!row || !row.id) return
      delDmpPackageById({ id: row.id }).then((data) => {
        if (typeof data !== 'symbol') this.getData()
      })
    },
    updateClick(row) {
      if (!row || !row.id) return
      this.$set(row, '_uping', true)
      setAutoUpdatePackage({
        id: row.id,
        // autoSwitch: Number(!row.autoSwitch)
        autoSwitch: this.autoSwitch
      }).then((data) => {
        if (typeof data !== 'symbol') {
          this.$set(row, '_uping', false)
          this.getData()
        }
      })
    },
    editSet(row) {
      if (!row || !row.id) return
      this.id = row.id
      this.excludeMedia = row.excludeMediaIds || []
      this.model = true
    },
    handleBatch() {
      if (this.selectionRow.length) {
        this.batch = true
      } else {
        this.$Message.info('请至少选择一个DMP包')
      }
    },
    batchDel() {
      if (this.selectionRow.length) {
        this.$Modal.confirm({
          title: '提示',
          content: '已选择' + this.selectionRow.length + '个人群包，确定要删除吗？',
          onOk: () => {
            const idsArr = []
            this.selectionRow.forEach((item) => {
              idsArr.push(item.id)
            })
            const params = {
              packageIdList: idsArr
            }
            batchDeleteDmpPackage(params).then((data) => {
              this.$Message.success('删除成功')
              this.getData()
            })
          }
        })
      } else {
        this.$Message.info('请至少选择一个DMP包')
      }
    },
    changeSelection(val) {
      if (isArray(val)) {
        this.selectionRow = val.map((e) => {
          return e
        })
      }
    },
    batchDeliverDmp(params) {
      this.loading = true
      dmpBatchDeliver(params)
        .then((data) => {
          data.forEach((ret) => {
            // ret.pushResult = ret.pushResult === 1 ? '成功' : '失败'
            ret.pushResult = '成功' + ret.successNum + '个账号，失败' + ret.failedNum + '个'
          })
          this.batchResultData = data
          this.loading = false
          this.batchResult = true
          this.getData()
        })
        .catch(() => {
          this.loading = false
          console.log('error')
        })
      this.batch = false
    },
    cancelBatch() {
      this.batch = false
    },
    batchResultClose() {
      this.batchResult = false
    },
    save() {
      this.saving = true
      setExcludeMedia({ id: this.id, mediaIds: this.excludeMedia }).then((data) => {
        if (typeof data !== 'symbol') {
          this.saving = false
          this.model = false
          this.getData()
        }
      })
    },
    getData(filter) {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...filter
      }
      this.loading = true
      dmpMangePackage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = tableColumns
              this.tableData = list.map((ret) => {
                ret.excludeMediaNames = ret.excludeMediaNames ? ret.excludeMediaNames.split(',') : []
                return ret
              })
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    changeStatus($event, row) {
      this.autoSwitch = $event
      this.updateClick(row)
    }
  },
  filters: {
    cellDmpType(cell) {
      if (cell === 1) return 'OAID原值'
      else if (cell === 2) return 'IMEI原值'
      else if (cell === 3) return 'IDFA原值'
      else if (cell === 4) return '手机号加密值'
    },
    cellAutoSwitch(cell) {
      return cell ? '正常' : '已停止'
    }
  },
  activated() {
    // 添加回来刷新
    if (this.tableData.length) this.getData()
    else this.filterData({})
  }
}
</script>
<style lang="scss" scoped>
.c-dmp-wrapper {
  .exclude-media-names {
    position: relative;

    &:hover {
      .m-edit {
        display: block;
      }
    }

    .m-edit {
      cursor: pointer;
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
      display: none;
      color: #1974ff;
    }
  }

  .tag-wrap {
    width: 88%;
    display: inline-block;
  }
  ::v-deep .ivu-tag .ivu-tag-text {
    width: auto;
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
